import React, { useState } from 'react';
import { ProductVariant } from '../../data/servicesData';
import SpecificationsGrid from './SpecificationsGrid';
import SpecificationsGallery from './SpecificationsGallery';

interface SpecificationsTabsProps {
  variants: ProductVariant[];
}

const SpecificationsTabs: React.FC<SpecificationsTabsProps> = ({
  variants
}) => {
  const [activeVariantId, setActiveVariantId] = useState<string>(
    variants[0]?.id || ''
  );

  const activeVariant = variants.find(v => v.id === activeVariantId);

  return (
    <div className="specifications-tabs-container">
      {/* Tab Navigation */}
      <div className="tabs-navigation" role="tablist">
        {variants.map((variant) => (
          <button
            key={variant.id}
            className={`tab-button ${activeVariantId === variant.id ? 'active' : ''}`}
            onClick={() => setActiveVariantId(variant.id)}
            role="tab"
            aria-selected={activeVariantId === variant.id}
            aria-controls={`panel-${variant.id}`}
          >
            {variant.name}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tabs-content">
        {activeVariant && (
          <div
            id={`panel-${activeVariant.id}`}
            className="tab-panel active"
            role="tabpanel"
          >
            {/* Optional variant description */}
            {activeVariant.description && (
              <p className="variant-description">{activeVariant.description}</p>
            )}

            {/* Specifications Layout */}
            <div className="specifications-layout">
              <SpecificationsGrid specifications={activeVariant.specifications} />

              {activeVariant.gallery && activeVariant.gallery.length > 0 && (
                <SpecificationsGallery
                  images={activeVariant.gallery}
                  title={activeVariant.name}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpecificationsTabs;
